import * as React from 'react'

function IconOvalTime({
  isFill,
  props,
}: {
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={144}
      viewBox="0 0 104 144"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#filter4_oval)">
            <path
              d="M52 143c28.167 0 51-31.788 51-71S80.167 1 52 1C23.834 1 1 32.788 1 72s22.834 71 51 71z"
              fill="#fff"
            />
            <path
              d="M52 143c28.167 0 51-31.788 51-71S80.167 1 52 1C23.834 1 1 32.788 1 72s22.834 71 51 71z"
              stroke="#A2A2A2"
              strokeWidth={2}
              strokeMiterlimit={10}
            />
            <path
              d="M52 134.7c-23.536 0-42.703-28.151-42.703-62.728 0-34.576 19.14-62.728 42.704-62.728 23.536 0 42.702 28.152 42.702 62.728 0 34.604-19.139 62.728-42.703 62.728z"
              fill="#A2A2A2"
            />
            <path
              d="M52.163 92.81c11.669 0 21.128-9.429 21.128-21.06 0-11.633-9.46-21.062-21.128-21.062-11.669 0-21.128 9.43-21.128 21.061 0 11.632 9.46 21.062 21.128 21.062z"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
            <path
              d="M52.163 60.38v8.239c0 2.004.797 3.93 2.222 5.35l4.84 4.825"
              stroke="#fff"
              strokeWidth={6}
              strokeMiterlimit={10}
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              id="filter4_oval"
              x={0}
              y={0}
              width={104}
              height={144}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M52 143c28.167 0 51-31.788 51-71S80.167 1 52 1C23.834 1 1 32.788 1 72s22.834 71 51 71z"
            fill="#fff"
          />
          <path
            d="M52 143c28.167 0 51-31.788 51-71S80.167 1 52 1C23.834 1 1 32.788 1 72s22.834 71 51 71z"
            stroke="#A2A2A2"
            strokeWidth={2}
            strokeMiterlimit={10}
          />
          <path
            d="M52 134.7c-23.536 0-42.703-28.152-42.703-62.728S28.437 9.244 52 9.244c23.537 0 42.703 28.152 42.703 62.728 0 34.604-19.139 62.728-42.703 62.728z"
            stroke="#A2A2A2"
            strokeWidth={0.75}
            strokeMiterlimit={10}
          />
          <path
            d="M52.163 92.81c11.669 0 21.128-9.429 21.128-21.06 0-11.633-9.46-21.062-21.128-21.062-11.669 0-21.128 9.43-21.128 21.061 0 11.632 9.46 21.062 21.128 21.062z"
            stroke="#A2A2A2"
            strokeWidth={5}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
          <path
            d="M52.163 60.38v8.239c0 2.004.797 3.93 2.222 5.35l4.84 4.825"
            stroke="#A2A2A2"
            strokeWidth={5}
            strokeMiterlimit={10}
            strokeLinecap="round"
          />
        </>
      )}
    </svg>
  )
}

export default IconOvalTime
